import React from "react";
import { Alert, Button } from "@mui/material";

export default function OccurrenceIssues({ rules, onResolve, disabled }) {
  const issues = rules.flatMap(rule => (rule.occurrenceIssues || []).map(issue => ({ rule, issue })));
  if (!issues.length) return null;
  return <Alert severity="warning">
    <strong>Dates need attention</strong>
    <p>No working hours were generated for these dates because a clock change affects a scheduled time. Other dates continue normally.</p>
    <ul>
      {issues.map(({ rule, issue }) => <li key={`${rule.availabilityRuleId}:${issue.localDate}`}>
        {issue.localDate}: {issue.localTime.replace("T", " ")} {issue.reason === "ambiguous" ? "occurs twice" : "does not exist"} in {rule.timezoneName}.
        <Button disabled={disabled} onClick={() => onResolve(rule, issue)} aria-label={`Resolve ${issue.localDate}`}>Change this date</Button>
      </li>)}
    </ul>
  </Alert>;
}
